<template>
  <div class="w-300px d-flex align-items-center">
    <el-button
        @click="isImport = true"
        type="primary"
        style="background: #472F92; border: none; color: white"
        class="btn btn-xs"
    >
      <i class="el-icon-star-off"></i> Import OKR
    </el-button>
    <el-button
        @click="isCreate = true"
        type="primary"
        style="background: #472F92; border: none; color: white"
        class="btn btn-xs"
    >
      <i class="el-icon-plus"></i> Thêm mới OKR
    </el-button>
    <el-dialog
        class="responsive" v-if="isCreate" width="40%"
        :visible.sync="isCreate" :show-close="false" :close-on-click-modal="false"
        append-to-body title="Thêm mới OKR" destroy-on-close
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray"/>
      <FormOKR @closeDialog="isCreate = false" @getListOkr="getListOkr"/>
    </el-dialog>
    <el-dialog
        class="responsive" :width="widthDialog"
        v-if="isImport" :visible.sync="isImport" :show-close="false"
        append-to-body :title="title" @close="closeDialog">
      <hr style="margin-top: -20px; border: 1px solid lightgray; margin-bottom: 20px"/>
      <DialogImportOkr
          @closeDialog="closeDialog"
          @getListOkr="getListOkr"
          @setTitleError="setTitleDialogError"
      />
    </el-dialog>
  </div>
</template>

<script>
import FormOKR from "@/view/pages/manage-okrs/component/FormOKR.vue";
import DialogImportOkr from "@/view/pages/manage-okrs/component/DialogImportOkr.vue";

export default {
  name: 'HeaderOKRs',
  components: { DialogImportOkr, FormOKR },
  data() {
    return {
      isCreate: false,
      isImport: false,
      title: "Import OKR",
      widthDialog: '40%',
    }
  },
  watch: {
    title(newVal) {
      if (newVal === "Import OKR") {
        this.widthDialog = '40%'
      } else {
        this.widthDialog = '80%'
      }
    }
  },
  methods: {
    getListOkr() {
      this.$emit('getListOkr')
    },
    setTitleDialogError(value) {
      this.title = value
    },
    closeDialog() {
      this.listErrors = []
      this.fileImport = null
      this.tableError = false
      this.disableImport = false
      this.isImport = false
      this.title = "Import OKR"
    },
  }
}
</script>

<style scoped>

</style>